import { render } from "./_docx.vue?vue&type=template&id=4246a337"
import script from "./_docx.vue?vue&type=script&lang=js"
export * from "./_docx.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__